import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export const ConfirmExitModal = ({
  isOpen,
  close,
  cancel,
}: {
  isOpen: boolean;
  close: () => void;
  cancel: () => void;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    title="Unsaved changes"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        You have unsaved changes. Please save them before exiting to avoid
        losing any progress
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={cancel}
          className="w-[180px]"
        >
          Discard changes
        </Button>
        <Button color="neutral" onClick={close} className="w-[180px]">
          Continue editing
        </Button>
      </div>
    </div>
  </Modal>
);
